module.exports = __webpack_public_path__ + "media/images/flags/1x1/hnd-4404009e6a0e6c585053f8ff737ef531.svg";